import Vue from 'vue';
import Router from 'vue-router';
import store from './store';
import Home from './views/Home.vue';

Vue.use(Router);

//统一吞掉重复导航异常：点击当前页菜单/页签时 vue-router3 会 reject NavigationDuplicated
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject) {
		return originalPush.call(this, location, onResolve, onReject);
	}
	return originalPush.call(this, location).catch(err => {
		if (err && err.name === 'NavigationDuplicated') {
			return err;
		}
		return Promise.reject(err);
	});
};

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'Home',
			component: Home,
			meta: {
				title: '让每个决策都有数据支撑'
			}
		},
		{
			path: '/workbench',
			name: 'Workbench',
			component: () => import('./views/workbench/Index'),
			meta: {
				title: '代账工作台'
			}
		},
		{
			path: '/voucher',
			name: 'Voucher',
			component: () => import('./views/voucher/Index'),
			meta: {
				title: '凭证列表'
			}
		},
		{
			path: '/voucher/auto-transfer',
			name: 'AutoTransfer',
			component: () => import('./views/voucher/AutoTransfer'),
			meta: {
				title: '自动转账'
			}
		},
		{
			path: '/jxc-voucher',
			name: 'JxcVoucher',
			component: () => import('./views/voucher/JxcVoucher'),
			meta: {
				title: '进销存单据'
			}
		},
		{
			path: '/jxc-setting',
			name: 'JxcSetting',
			component: () => import('./views/setting/JxcSetting'),
			meta: {
				title: '进销存设置'
			}
		},
		{
			path: '/voucher/form/:voucherId(\\d+)?',
			name: 'VoucherForm',
			component: () => import('./views/voucher/VoucherForm'),
			props: true,
			meta: {
				title: '凭证信息'
			}
		},
		{
			path: '/check-out',
			name: 'CheckOut',
			component: () => import('./views/checkout/Index'),
			children: [
				{
					path: 'list',
					name: 'CheckList',
					component: () => import('./views/checkout/CheckList'),
					meta: {
						title: '结账'
					}
				},
				{
					path: 'un-check',
					name: 'UnCheckOut',
					component: () => import('./views/checkout/UnCheckOut'),
					meta: {
						title: '反结账'
					}
				}, {
					path: 'carry-forward/:checkYear(\\d+)/:checkMonth(\\d+)',
					name: 'CarryForward',
					props: true,
					component: () => import('./views/checkout/CarryForward'),
					meta: {
						title: '月末结转'
					}
				}, {
					path: 'check/:checkYear(\\d+)/:checkMonth(\\d+)',
					name: 'Check',
					props: true,
					component: () => import('./views/checkout/Check'),
					meta: {
						title: '检查'
					}
				}
			]
		},
		{
			path: '/account',
			name: 'Account',
			component: () => import('./views/setting/Account'),
			meta: {
				title: '账套'
			}
		},
		{
		path: '/subject',
		name: 'Subject',
		component: () => import('./views/setting/Subject'),
		meta: {
			title: '科目'
		}
	},
	{
		path: '/sets-settings',
		name: 'SetsSettings',
		component: () => import('./views/setting/SetsSettings'),
		meta: {
			title: '参数中心'
		}
	},
		{
			path: '/initial',
			name: 'Initial',
			component: () => import('./views/setting/Initial'),
			meta: {
				title: '期初'
			}
		},
		{
			path: '/voucher-word',
			name: 'VoucherWord',
			component: () => import('./views/setting/VoucherWord'),
			meta: {
				title: '凭证字'
			}
		},
		{
		path: '/currency',
		name: 'Currency',
		component: () => import('./views/setting/Currency'),
		meta: {
			title: '币别'
		}
	},
	{
		path: '/exchange-rate',
		name: 'ExchangeRate',
		component: () => import('./views/setting/ExchangeRate'),
		meta: {
			title: '汇率管理'
		}
	},
		{
			path: '/assisting-accounting',
			name: 'AssistingAccounting',
			component: () => import('./views/setting/AssistingAccounting'),
			meta: {
				title: '辅助核算'
			},
			children: [
				{
					path: 'accounting-category',
					name: 'AccountingCategory',
					component: () => import('./views/setting/AssistingAccounting/AccountingCategory'),
					meta: {
						title: '辅助核算类别'
					}
				},
				{
					path: 'custom/:id(\\d+)',
					name: 'CategoryCustom',
					component: () => import('./views/setting/AssistingAccounting/CategoryCustom'),
					props: true,
					meta: {
						title: '自定类别'
					}
				}
			]
		},
		{
			path: '/template',
			component: () => import('./views/setting/template/Index'),
			meta: {
				title: '模板管理'
			},
			children: [{
				path: 'manager',
				name: 'TemplateManager',
				component: () => import('./views/setting/template/TemplateManager'),
				meta: {
					title: '模板管理'
				}
			}, {
				path: 'design/:templateId(\\d+)?',
				name: 'TemplateDesign',
				component: () => import('./views/setting/template/TemplateDesign'),
				props: true,
				meta: {
					title: '模板设计'
				}
			}]
		},
		{
			path: '/permission-setting',
			name: 'PermissionSetting',
			component: () => import('./views/setting/PermissionSetting'),
			meta: {
				title: '权限设置'
			}
		},
		{
			path: '/role',
			name: 'RoleManage',
			component: () => import('./views/setting/RoleManage'),
			meta: {
				title: '角色管理'
			}
		},
		{
			path: '/personal',
			name: 'Personal',
			component: () => import('./views/personal/Index'),
			meta: {
				title: '个人设置'
			},
			children: [
				{
					path: 'personal-setting',
					name: 'PersonalSetting',
					component: () => import('./views/personal/PersonalSetting'),
					meta: {
						title: '个人设置'
					}
				},
				{
					path: 'change-password',
					name: 'ChangePassword',
					component: () => import('./views/personal/ChangePassword'),
					meta: {
						title: '修改密码'
					}
				},
				{
					path: 'change-phone-number',
					name: 'ChangePhoneNumber',
					component: () => import('./views/personal/ChangePhoneNumber'),
					meta: {
						title: '修改手机'
					}
				},
				{
					path: 'binding-webchat',
					name: 'BindingWebchat',
					component: () => import('./views/personal/BindingWebchat'),
					meta: {
						title: '绑定微信'
					}
				}
			]
		},
		{
			path: '/assets-category',
			name: 'AssetsCategory',
			component: () => import('./views/assets/Category'),
			meta: {
				title: '固定资产类别'
			}
		},
		{
			path: '/assets',
			name: 'Assets',
			component: () => import('./views/assets/Assets'),
			meta: {
				title: '固定资产'
			}
		},
		{
			path: '/funds-account',
			name: 'FundsAccount',
			component: () => import('./views/funds/Account'),
			meta: {
				title: '资金账户'
			}
		},
		{
			path: '/funds-category',
			name: 'FundsCategory',
			component: () => import('./views/funds/Category'),
			meta: {
				title: '收支分类'
			}
		},
		{
			path: '/funds-journal',
			name: 'FundsJournal',
			component: () => import('./views/funds/Journal'),
			meta: {
				title: '资金日记账'
			}
		},
		{
			path: '/salary-employee',
			name: 'SalaryEmployee',
			component: () => import('./views/salary/Employee'),
			meta: {
				title: '员工档案'
			}
		},
		{
			path: '/salary',
			name: 'Salary',
			component: () => import('./views/salary/Salary'),
			meta: {
				title: '工资管理'
			}
		},
		{
			path: '/account-book/detailed',
			name: 'DetailedAccounts',
			component: () => import('./views/accountbook/DetailedAccounts'),
			meta: {
				title: '明细账'
			}
		},
		{
			path: '/account-book/cashier-journal',
			name: 'CashierJournal',
			component: () => import('./views/accountbook/CashierJournal'),
			meta: {
				title: '出纳日记账'
			}
		},
		{
			path: '/account-book/general-ledger',
			name: 'GeneralLedger',
			component: () => import('./views/accountbook/GeneralLedger'),
			meta: {
				title: '总账'
			}
		},
		{
			path: '/account-book/subject-balance',
			name: 'SubjectBalance',
			component: () => import('./views/accountbook/SubjectBalance'),
			meta: {
				title: '科目余额'
			}
		},
		{
			path: '/account-book/subject-summary',
			name: 'SubjectSummary',
			component: () => import('./views/accountbook/SubjectSummary'),
			meta: {
				title: '科目汇总'
			}
		},
		{
			path: '/account-book/auxiliary-accounting-balance',
			name: 'AuxiliaryAccountingBalance',
			component: () => import('./views/accountbook/AuxiliaryAccountingBalance'),
			meta: {
				title: '辅助核算余额'
			}
		},
		{
			path: '/account-book/auxiliary-accounting-detail',
			name: 'AuxiliaryAccountingDetail',
			component: () => import('./views/accountbook/AuxiliaryAccountingDetail'),
			meta: {
				title: '辅助核算明细账'
			}
		},
		{
			path: '/report',
			name: 'ReportList',
			component: () => import('./views/report/ReportList'),
			meta: {
				title: '报表'
			}
		},
		{
			path: '/report/custom',
			name: 'CustomReport',
			component: () => import('./views/report/CustomReport'),
			meta: {
				title: '自定义报表'
			}
		},
		{
			path: '/report/view/:reportId(\\d+)',
			name: 'ReportView',
			props: true,
			component: () => import('./views/report/ReportView'),
			meta: {
				title: '报表数据'
			}
		},
		{
			path: '/report/profit-quarter',
			name: 'ProfitQuarter',
			component: () => import('./views/report/ReportView'),
			meta: {
				title: '利润表季报',
				symbol: 'lrb',
				quarter: true
			}
		},
		{
			path: '/report/cashflow-quarter',
			name: 'CashFlowQuarter',
			component: () => import('./views/report/ReportView'),
			meta: {
				title: '现金流量表季报',
				symbol: 'xjllb',
				quarter: true
			}
		},
		{
			path: '/report/template',
			name: 'ReportTemplate',
			component: () => import('./views/report/template/TemplateList'),
			meta: {
				title: '报表模板'
			}
		},
		{
			path: '/report/template/form/:templateId(\\d+)',
			name: 'TemplateForm',
			props: true,
			component: () => import('./views/report/template/TemplateForm'),
			meta: {
				title: '模板编辑'
			}
		},
		{
			path: '/voucher/tripartite',
			name: 'Tripartite',
			component: () => import('./views/voucher/Tripartite'),
			meta: {
				title: '业务凭证'
			}
		},
		{
			path: '/voucher/tripartite/:definitionId(\\d+)',
			name: 'TripartiteData',
			props: true,
			component: () => import('./views/voucher/TripartiteData'),
			meta: {
				title: '业务凭证数据'
			}
		},
		{
			path: '/invoice/output',
			name: 'OutputInvoice',
			component: () => import('./views/invoice/OutputInvoice'),
			meta: {
				title: '销项发票'
			}
		},
		{
			path: '/invoice/input',
			name: 'InputInvoice',
			component: () => import('./views/invoice/InputInvoice'),
			meta: {
				title: '进项发票'
			}
		},
		{
			path: '/invoice/intelligent',
			name: 'IntelligentInvoicing',
			component: () => import('./views/invoice/IntelligentInvoicing'),
			meta: {
				title: '智能开票'
			}
		},
		{
			path: '/invoice/check-select',
			name: 'InvoiceCheckSelect',
			component: () => import('./views/invoice/InvoiceCheckSelect'),
			meta: {
				title: '发票勾选'
			}
		},
		{
			path: '/invoice/expense',
			name: 'Expense',
			component: () => import('./views/invoice/Expense'),
			meta: {
				title: '费用单据'
			}
		},
		{
			path: '/invoice/non-income',
			name: 'NonIncome',
			component: () => import('./views/invoice/NonIncome'),
			meta: {
				title: '无票收入'
			}
		},
		{
			path: '/funds/transfer',
			name: 'InternalTransfer',
			component: () => import('./views/funds/Transfer'),
			meta: {
				title: '内部转账'
			}
		},
		{
			path: '/funds/report',
			name: 'FundsReport',
			component: () => import('./views/funds/FundsReport'),
			meta: {
				title: '资金报表'
			}
		},
		{
			path: '/funds/check-up',
			name: 'CheckUp',
			component: () => import('./views/funds/CheckUp'),
			meta: {
				title: '核对总账'
			}
		},
		{
			path: '/salary/social-security',
			name: 'SocialSecurity',
			component: () => import('./views/salary/SocialSecurity'),
			meta: {
				title: '五险一金设置'
			}
		},
		{
			path: '/tax/declare',
			name: 'DeclareInfo',
			component: () => import('./views/tax/DeclareInfo'),
			meta: {
				title: '企业税申报'
			}
		},
		{
			path: '/tax/annual',
			name: 'GsAnnual',
			component: () => import('./views/tax/GsAnnual'),
			meta: {
				title: '工商年报'
			}
		},
		{
			path: '/tax/check',
			name: 'TaxCheck',
			component: () => import('./views/tax/TaxCheck'),
			meta: {
				title: '漏报检查'
			}
		},
		{
			path: '/setting/audit-log',
			name: 'AuditLog',
			component: () => import('./views/setting/AuditLog'),
			meta: {
				title: '审计日志'
			}
		},
		{
			path: '/setting/backup',
			name: 'Backup',
			component: () => import('./views/setting/Backup'),
			meta: {
				title: '备份恢复'
			}
		},
		{
			path: '/account-book/time-series',
			name: 'TimeSeries',
			component: () => import('./views/accountbook/TimeSeries'),
			meta: {
				title: '序时账'
			}
		},
		{
			path: '/account-book/multi-column',
			name: 'MultiColumnLedger',
			component: () => import('./views/accountbook/MultiColumnLedger'),
			meta: {
				title: '多栏账'
			}
		},
		{
			path: '/account-book/age-analysis',
			name: 'AgeAnalysis',
			component: () => import('./views/accountbook/AgeAnalysis'),
			meta: {
				title: '账龄分析表'
			}
		},
		{
			path: '/assets/summary',
			name: 'AssetsSummary',
			component: () => import('./views/assets/AssetsSummary'),
			meta: {
				title: '资产汇总'
			}
		},
		{
			path: '/assets/depreciation-list',
			name: 'AssetsDepreciationList',
			component: () => import('./views/assets/DepreciationList'),
			meta: {
				title: '折旧摊销明细表'
			}
		},
		{
			path: '/report/fee-detail',
			name: 'FeeDetailReport',
			component: () => import('./views/report/FeeDetailReport'),
			meta: {
				title: '费用明细表'
			}
		},
		{
			path: '/admin',
			component: () => import('./views/admin/Layout'),
			redirect: '/admin/dashboard',
			children: [
				{
					path: 'dashboard',
					name: 'AdminDashboard',
					component: () => import('./views/admin/Dashboard'),
					meta: {
						title: '首页'
					}
				},
				{
					path: 'account-sets',
					name: 'AdminAccountSets',
					component: () => import('./views/admin/AccountSets'),
					meta: {
						title: '账套管理'
					}
				},
				{
					path: 'users',
					name: 'AdminUsers',
					component: () => import('./views/admin/Users'),
					meta: {
						title: '用户管理'
					}
				},
				{
					path: 'account-templates',
					name: 'AdminAccountTemplates',
					component: () => import('./views/admin/AccountSetTemplates'),
					meta: {
						title: '账套模板'
					}
				},
				{
					path: 'admin-accounts',
					name: 'AdminAccounts',
					component: () => import('./views/admin/AdminAccounts'),
					meta: {
						title: '管理账号'
					}
				},
				{
					path: 'site-settings',
					name: 'AdminSiteSettings',
					component: () => import('./views/admin/SiteSettings'),
					meta: {
						title: '站点设置'
					}
				},
				{
					path: 'version-management',
					name: 'AdminVersionManagement',
					component: () => import('./views/admin/VersionManagement'),
					meta: {
						title: '版本管理'
					}
				},
				{
					path: 'renewal-codes',
					name: 'AdminRenewalCodes',
					component: () => import('./views/admin/RenewalCodes'),
					meta: {
						title: '续订代码'
					}
				},
				{
					path: 'announcements',
					name: 'AdminAnnouncements',
					component: () => import('./views/admin/Announcements'),
					meta: {
						title: '系统公告'
					}
				},
				{
					path: 'permission-management',
					name: 'AdminPermissionManagement',
					component: () => import('./views/admin/PermissionManagement'),
					meta: {
						title: '权限管理'
					}
				},
				{
					path: 'payment',
					name: 'AdminPayment',
					component: () => import('./views/admin/Payment'),
					meta: {
						title: '收款配置'
					}
				},
				{
					path: 'ai-config',
					name: 'AdminAiConfig',
					component: () => import('./views/admin/AiConfig'),
					meta: {
						title: '智能体配置'
					}
				},
				{
					path: 'logs',
					name: 'AdminLogs',
					component: () => import('./views/admin/Logs'),
					meta: {
						title: '操作日志'
					}
				},
				{
					path: 'login-logs',
					name: 'AdminLoginLogs',
					component: () => import('./views/admin/LoginLogs'),
					meta: {
						title: '登录日志'
					}
				}
			]
		},
		{
			path: '/tax/iit',
			name: 'IitDeclare',
			component: () => import('./views/tax/Iit'),
			meta: {
				title: '个税申报'
			}
		},
		{
			path: '/tax/scjy',
			name: 'ScjyDeclare',
			component: () => import('./views/tax/Scjy'),
			meta: {
				title: '生产经营所得申报'
			}
		},
		{
			path: '/tax/social',
			name: 'SocialDeclare',
			component: () => import('./views/tax/Social'),
			meta: {
				title: '社保费申报'
			}
		},
		{
			path: '/tax/scjy-annual',
			name: 'ScjyAnnual',
			component: () => import('./views/tax/Scjy'),
			meta: {
				title: '生产经营所得年度汇缴',
				annual: true
			}
		},
		{
			path: '/tax/shbx-gd',
			name: 'ShbxGdDeclare',
			component: () => import('./views/tax/ShbxGd'),
			meta: {
				title: '社保费申报(广东)'
			}
		},
		{
			path: '/report/assets-check',
			name: 'AssetsCheck',
			component: () => import('./views/report/AssetsCheck'),
			meta: {
				title: '资产对账'
			}
		},
		{
			path: '/setting/audit-export',
			name: 'AuditExport',
			component: () => import('./views/setting/AuditExport'),
			meta: {
				title: '审计数据导出'
			}
		},
		{
			path: '/setting/sync',
			name: 'SyncImport',
			component: () => import('./views/setting/SyncImport'),
			meta: {
				title: '旧账导入'
			}
		},
		{
			path: '/ai-agent',
			name: 'AiAgent',
			component: () => import('./views/agent/AiAgent'),
			meta: {
				title: '财税智能体'
			}
		},
		{
			path: '/inventory/check',
			name: 'InventoryCheck',
			component: () => import('./views/inventory/Check'),
			meta: {
				title: '存货盘点'
			}
		},
		{
			path: '/inventory/fund',
			name: 'InventoryFund',
			component: () => import('./views/inventory/Fund'),
			meta: {
				title: '存货资金单'
			}
		},
		{
			path: '/inventory/bill-manager',
			name: 'InventoryBillManager',
			component: () => import('./views/inventory/BillManager'),
			meta: {
				title: '单据管理'
			}
		},
		{
			path: '/inventory/fund-management',
			name: 'InventoryFundManagement',
			component: () => import('./views/inventory/FundManagement'),
			meta: {
				title: '资金管理'
			}
		},
		{
			path: '/inventory/report',
			name: 'InventoryReport',
			component: () => import('./views/inventory/InventoryReport'),
			meta: {
				title: '统计报表'
			}
		},
		{
			path: '/inventory/opening-balance',
			name: 'InventoryOpeningBalance',
			component: () => import('./views/inventory/OpeningBalance'),
			meta: {
				title: '期初数据'
			}
		},
		{
			path: '/inventory/basic-setting',
			name: 'InventoryBasicSetting',
			component: () => import('./views/inventory/BasicSetting'),
			meta: {
				title: '基础设置'
			}
		},
		{
			path: '/inventory/cost-period',
			name: 'InventoryCostPeriod',
			component: () => import('./views/inventory/CostPeriod'),
			meta: {
				title: '成本核算期间'
			}
		}
	]
});

//管理后台路由守卫：仅平台管理员（BOSS）可访问
router.beforeEach((to, from, next) => {
	if (to.path.indexOf('/admin') === 0) {
		let user = store.state.User || {};
		if (user.role !== 'BOSS') {
			next({name: 'Home'});
			return;
		}
	}
	next();
});

export default router;
